module.exports = __webpack_public_path__ + "media/images/icon-user-ef923e59d0a9cfaed73cca4734563fb0.svg";